const styles = theme => ({
  namingModalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '10px',
  },
})

export default styles
